import * as actionTypes from "../action-types";

const initialState = {
    //! Admin
    adminData: [],
    adminByIdData: null,
    //* Partner
    partnerByAdminIdData: [],
    //* Partner Bank Detail
    partnerBankDetailData: [],
    activePartnerBankDetailData: null,

    //! Admin Report Wallet
    adminReportWalletData: [],

    //! Registration Number
    registrationNumberData: [],

    //! Video: Tutorials & Business
    tutorialVideoData: [],
    businessVideoData: [],

    //! Blog
    blogData: [],
    blogByIdData: null,

    //! Coupon
    couponData: [],

    //! Reports
    reportModulesData: [],
    reportData: [],
    generatedReportsData: [],
    customersAllData: [],

    //! Static Page
    termsofUseData: null,
    privacyPolicyData: null,
    shippingPolicyData: null,
    refundPolicyData: null,
    aboutUsData: null,

    //! Bug Tracker
    bugReportsData: [],
    bugReportByIdData: null,
    bugStatsData: null,
    searchBugReportsData: [],

    //! Site Settings
    siteSettingsData: null,

    //! Awards
    awardData: [],

    //! Media Coverage
    mediaCoverageData: [],

    //! Testimonial Videos
    testimonialVideoData: [],
};

const superadminReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Admin
        case actionTypes.SET_ADMINS:
            return { ...state, adminData: payload };

        case actionTypes.SET_ADMIN_BY_ID:
            return { ...state, adminByIdData: payload };

        //* Partner
        case actionTypes.SET_PARTNER_BY_ADMINID:
            return { ...state, partnerByAdminIdData: payload };

        //* Partner Bank Detail
        case actionTypes.SET_PARTNER_BANK_DETAILS:
            return { ...state, partnerBankDetailData: payload };

        case actionTypes.SET_ACTIVE_PARTNER_BANK_DETAIL:
            return { ...state, activePartnerBankDetailData: payload };

        //! Admin Report Wallet
        case actionTypes.SET_ADMIN_REPORT_WALLETS:
            return { ...state, adminReportWalletData: payload };

        //! Registration Number
        case actionTypes.SET_REGISTRATION_NUMBERS:
            return { ...state, registrationNumberData: payload };

        //! Video: Tutorials & Business
        case actionTypes.SET_TUTORIAL_VIDEOS:
            return { ...state, tutorialVideoData: payload };

        case actionTypes.SET_BUSINESS_VIDEOS:
            return { ...state, businessVideoData: payload };

        //! Blog
        case actionTypes.SET_BLOGS:
            return { ...state, blogData: payload || [] };

        case actionTypes.SET_BLOG_BY_ID:
            return { ...state, blogByIdData: payload || null };

        //! Coupon
        case actionTypes.SET_COUPONS:
            return { ...state, couponData: payload };

        //! Reports
        case actionTypes.SET_REPORT_MODULES:
            return { ...state, reportModulesData: payload };

        case actionTypes.SET_REPORTS:
            return { ...state, reportData: payload };

        case actionTypes.SET_GENERATED_REPORTS:
            return { ...state, generatedReportsData: payload };
        case actionTypes.SET_CUSTOMERS_ALL:
            return { ...state, customersAllData: payload };

        //! Static Page
        case actionTypes.SET_TERMS_OF_USE:
            return { ...state, termsofUseData: payload };

        case actionTypes.SET_PRIVACY_POLICY:
            return { ...state, privacyPolicyData: payload };

        case actionTypes.SET_SHIPPING_POLICY:
            return { ...state, shippingPolicyData: payload };

        case actionTypes.SET_REFUND_POLICY:
            return { ...state, refundPolicyData: payload };

        case actionTypes.SET_ABOUT_US:
            return { ...state, aboutUsData: payload };

        //! Bug Tracker
        case actionTypes.SET_BUG_REPORTS:
            return { ...state, bugReportsData: payload };

        case actionTypes.SET_BUG_REPORT_BY_ID:
            return { ...state, bugReportByIdData: payload };

        case actionTypes.SET_BUG_STATS:
            return { ...state, bugStatsData: payload };

        case actionTypes.SET_SEARCH_BUG_REPORTS:
            return { ...state, searchBugReportsData: payload };

        //! Site Settings
        case actionTypes.SET_SITE_SETTINGS:
            return { ...state, siteSettingsData: payload };

        //! Awards
        case actionTypes.SET_AWARDS:
            return { ...state, awardData: payload };

        //! Media Coverage
        case actionTypes.SET_MEDIA_COVERAGE:
            return { ...state, mediaCoverageData: payload };

        //! Testimonial Videos
        case actionTypes.SET_TESTIMONIAL_VIDEOS:
            return { ...state, testimonialVideoData: payload };

        default:
            return state;
    }
};

export default superadminReducer;